import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/integracaoExport/';

class IntegracaoService{
  constructor(){
    LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type':'application/json',
				'authorization':'Bearer ' + (data ? data.token:'')
			};
		});
  }

  saveIntegracao(integracao){
    console.log(JSON.stringify(integracao));
    return axios.post(API_URL+'create', JSON.stringify(integracao), {headers: this.headers});
  }

  findAllByCliente(idCliente) {
    return axios.get(API_URL + 'all?idCliente='+idCliente, {headers: this.headers});
  }
}

export default new IntegracaoService();